import * as React from 'react';
import * as autoBind from 'react-autobind';
import {ControlButton, TscButtonType, BasicModal, TextInput} from '@techsmith/tsc-cloud-style-guide';
import Themeable from '../../types/Themeable';
import ReviewModel from '../../types/ReviewModel';
import Strings from '../../globals/Strings';
import Constants from '../../globals/Constants';
import ReviewService from '../../services/ReviewService/ReviewService';
import UpdateReviewModel from '../../types/UpdateReviewModel';
import GoogleAnalyticsService from '../../services/GoogleAnalyticsService/GoogleAnalyticsService';
import Store from '../../redux/Store';
import UserMessaging from '../../utils/UserMessaging';

export default class EditTitleModal extends React.Component<EditTitleModalProps> {
   readonly state: EditTitleModalState = {isSaving: false, title: this.props.review.Title};

   constructor(props: EditTitleModalProps) {
      super(props);
      autoBind(this);
   }

   onCancel(): void {
      this.props.onClose();
   }

   onTitleChange(event: any): void {
      this.setState({title: event.target.value});
   }

   getTitleError(): string {
      const {title} = this.state;

      if (!title.trim()) {
         return Strings.errors.missingTitle;
      }

      if (title.length > Constants.title.maxLength) {
         return Strings.errors.invalidTitleLength.replace('{param0}', Constants.title.maxLength + '');
      }
   }

   async updateReview(): Promise<void> {
      const {review, onClose} = this.props;
      const {title} = this.state;
      const updatedReview: UpdateReviewModel = {
         Id: review.Id,
         Title: title.trim(),
         ReviewByDate: review.ReviewByDate,
         PrivacyType: null,
         Description: null,
         SendNotifications: false
      };

      if (review.Title !== updatedReview.Title) {
         GoogleAnalyticsService.trackEditReview(Store.getState().currentUserId, Constants.googleAnalytics.editReview.labels.editTitle);
      }

      this.setState({isSaving: true});
      try {
         await ReviewService.updateReview(updatedReview);
         this.setState({isSaving: false});
         onClose();
      } catch {
         this.setState({isSaving: false});
         UserMessaging.warn(Strings.errors.failedUpdateReview);
      }
   }

   render(): React.ReactElement<any> {
      const {visible, themeName} = this.props;
      const {title, isSaving} = this.state;
      const titleErrorText = this.getTitleError();
      const saveButtonDisabled = !!titleErrorText || isSaving || !title;

      return (
         <BasicModal visible={visible} title={Strings.titles.editReviewTitle} onClose={this.onCancel} themeName={themeName} testId="edit-review-title-modal">
            <div className="modal-body">
               <div className="review-modal-body">
                  <div className="modal-message">
                     <label htmlFor="review-details-title-input" className="input-label screen-reader-only">{Strings.labels.editReviewModal.title.title}</label>
                     <TextInput sharedId="review-details-title-input" themeName={themeName} placeholder={Strings.labels.editReviewModal.title.inputPlaceHolder} errorText={titleErrorText} value={title} onChange={this.onTitleChange} disabled={false} required={true} testId="edit-review-title-input"/>
                  </div>
                  <div className="button-group">
                     <ControlButton
                        disabled={false}
                        buttonType={TscButtonType.secondary}
                        themeName={themeName}
                        isFullWidth={true}
                        onClick={this.onCancel}
                        label={Strings.labels.cancel}
                        testId="edit-review-modal-cancel-button"
                     />
                     <ControlButton
                        disabled={saveButtonDisabled}
                        themeName={themeName}
                        buttonType={TscButtonType.primary}
                        isFullWidth={true}
                        onClick={this.updateReview}
                        label={Strings.labels.save}
                        testId="edit-review-modal-save-button"
                     />
                  </div>
               </div>
            </div>
         </BasicModal>
      );

   }
}

interface EditTitleModalProps extends Themeable {
   visible: boolean;
   review: ReviewModel;
   onClose(): void;
}

interface EditTitleModalState {
   isSaving: boolean;
   title: string;
}
